import { UserPlus } from 'lucide-react'

interface TeamMembersEmptyStateProps {
  onInvite?: () => void
  canInvite: boolean
}

export const TeamMembersEmptyState = ({ onInvite, canInvite }: TeamMembersEmptyStateProps) => {
  return (
    <div className="bg-white border border-gray-200 rounded-3xl p-10 text-center">
      <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-gray-100">
        <UserPlus className="h-7 w-7 text-gray-400" />
      </div>
      <h2 className="text-xl font-semibold text-gray-900">Invite your first team member</h2>
      <p className="mt-2 text-sm text-gray-500">
        Invite colleagues to help manage devices, tickets, and onboarding for your company.
      </p>
      {canInvite && (
        <button
          onClick={onInvite}
          className="mt-6 inline-flex items-center rounded-full bg-gray-900 px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-gray-800"
        >
          Invite Team Member
        </button>
      )}
    </div>
  )
}
